import { getApi } from "./api_instance";

export const getAllVerificationBodies = async (dispatch) => {
  try {
    const { data } = await getApi({
      apiUrl: "/projects/api/verification-body/getAllVerificationBodies",
      dispatch,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
